export default __webpack_public_path__ + "static/media/Leader.9315a7af.png";